<template>
  <div class="button" :class="{ selected: this.selected || this.dialogVisible}">
    <div :class="{ disabled: this.disabled }">
      <slot ></slot>
    </div>
    <div class="tooltip">{{toolname}}</div>
    <div class="confirm" v-if="dialogVisible" ref="dialog">
      <slot name="dialog"></slot>
    </div>
  </div>

</template>

<script>
export default {
  props: ['selected', 'toolname', 'disabled', 'confirm'],
  data () {
    return {
      dialogVisible: false,
    }
  },
  mounted () {
    this.dialogVisible = this.confirm;
  },
  watch: {
    confirm (val) {
      this.dialogVisible = val
    },
    dialogVisible (val) {
      if (val) {
        setTimeout(() => {
          document.addEventListener('click', this.clickOutsideHandler)
        },0)
        return;
      }
      document.removeEventListener('click', this.clickOutsideHandler)
    }
  },
  methods: {
    clickOutsideHandler (event) {
      if (!this.$refs.dialog.contains(event.target)) { // or use: event.target.closest(selector) === null
        this.dialogVisible = false
        this.$emit('dialogClose')
      }
    }
  }
}
</script>
<style scoped>
  .button {
    height: 32px;
    width: 44px;
    margin: 3px 0 3px 12px;
    display: flex;
    justify-content: left;
    align-items: center;
    border-radius: 3px 0 0 3px;
    padding-left: 3px;
    border: 1px solid #fff;
    cursor: pointer;
  }

  .button > div:first-child {
    height: 24px;
  }

  .disabled { 
    opacity: .4;
  }

  .button:hover {
    background-color: #e3e7eb
  }

  .selected { 
    /* background-color: #5650d733 */
    box-shadow: inset 0 4px 16px 0 rgba(86, 80, 215, 0.3);
    padding-left: 4px;
  }

  .tooltip {
    display:none;
    position: absolute;
    right: 66px;
    background-color: #3e4c59;
    padding: 2px 5px;
    color: white;
    font-size: .8rem;
    white-space: nowrap;
    border-radius: 3px;
    padding-top:3px;
  }

  .button:hover > .tooltip {
    display:block;
   
  }

  .tooltip:after, .confirm:after  {
    position: absolute;
    content: '';
    top: 5px;
    right: -4px;
    width: 0;
    height: 0;
    border-bottom: 5px solid transparent;
    border-top: 5px solid transparent;
    border-left: 5px solid #3e4c59;
  }

  .confirm:after  {
    top: calc(50% - 5px);
  }

  .confirm {
    position: absolute;
    right: 66px;
    background-color: #3e4c59;
    padding: 0px 5px;
    color: white;
    font-size: .8rem;
    white-space: nowrap;
    border-radius: 3px;
  }
</style>
